var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4378_89490)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8,
    width: 144,
    height: 176,
    rx: 15,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.644,
    y: -2,
    width: 141.476,
    height: 167.361,
    rx: 15,
    transform: "rotate(13.8615 45.644 -2)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.058 114.582H52.9375L43.8057 124.233L49.3055 142.912L73.7954 157.855L113.228 157.128L139.378 143.638L144.463 123.714L136.058 114.582Z",
    fill: "#0F548C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.171,
    cy: 62.6974,
    r: 26.8766,
    fill: "#0F548C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2356 28.9722C75.6812 28.9722 60.6399 44.0251 60.6399 62.5939C60.6399 81.1626 75.6812 96.2156 94.2356 96.2156C112.79 96.2156 127.831 81.1626 127.831 62.5939C127.831 44.0251 112.79 28.9722 94.2356 28.9722ZM69.0388 62.5939C69.0388 48.6673 80.3198 37.3776 94.2356 37.3776C108.151 37.3776 119.432 48.6673 119.432 62.5939C119.432 76.5204 108.151 87.8102 94.2356 87.8102C80.3198 87.8102 69.0388 76.5204 69.0388 62.5939ZM54.7602 109.664C46.8766 109.664 40.4825 116.057 40.4824 123.95L40.4824 126.475C40.4824 139.102 47.0056 148.554 57.0121 154.651C66.852 160.646 80.0786 163.459 94.2356 163.459C108.393 163.459 121.619 160.646 131.459 154.651C141.466 148.554 147.989 139.102 147.989 126.475L147.989 123.949C147.989 116.056 141.595 109.664 133.711 109.664H54.7602ZM48.8814 123.95C48.8814 120.702 51.5118 118.07 54.7602 118.07H133.711C136.96 118.07 139.59 120.702 139.59 123.949L139.59 126.475C139.59 135.702 135.02 142.641 127.092 147.471C118.997 152.403 107.446 155.054 94.2356 155.054C81.0249 155.054 69.4746 152.403 61.3796 147.471C53.4511 142.641 48.8814 135.702 48.8814 126.475L48.8814 123.95Z",
    fill: "#0F548C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4378_89490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ad82f8d7d85041099552dc1d1762ff6.svg";
export { ForwardRef as ReactComponent };